/*
 * @Author: Jackson
 * @Email: zhangjiajun@everimaging.com
 * @Date: 2021-01-12 17:17:36
 * @Description: 
 * 
 */

import './App.scss';
import React from 'react';
import Layout from 'src/components/Layout';
import "src/assets/font/index.scss"
// import ml5 from './ml5';
import utils from "src/utils"
import FTLang from 'src/utils/FTLang';
import FTUserStore from './store/FTUserStore';
import FTCanvasStore from './store/FTCanvasStore';
import FTAnalytic from './analyze/FTAnalytic';
import mousetrap from "mousetrap";
import FTImageStore from './store/FTImageStore';
import { message } from 'antd';
class Root extends React.Component<{}, {}> {
  state = {
    loadLanguage: false
  }
  componentDidMount() {
    this.loadLanguage()
    this.loadImageFromUrl()
    FTCanvasStore.init()
    FTUserStore.getShowCountryAd()
    this.loadLoginSdk()
    this.loadPaymentSdk()
    this.stopDragDefaultEvent()
    this.addKeyBoardEvent()
  }

  addKeyBoardEvent = () => {
    let Mousetrap = new mousetrap(document.body);
    Mousetrap.bind("left", () => {
      // FTImageStore.prev()
    })
    Mousetrap.bind("right", () => {
      // FTImageStore.next()
    })
  }

  stopDragDefaultEvent = () => {
    document.body.addEventListener('drop',e=>{
      e.stopPropagation();
      e.preventDefault();
    });
    document.body.addEventListener('dragover',e=>{
      e.stopPropagation();
      e.preventDefault();
    });
    
    // 阻止双击放大
    var lastTouchEnd = 0;
    document.addEventListener("touchstart", function(event) {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    });
    document.addEventListener(
      "touchend",
      function(event) {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
    // 阻止双指放大
    document.addEventListener("gesturestart", function(event) {
      event.preventDefault();
    });
  }

  loadImageFromUrl = () => {
    let search = window.location.search.slice(1)
    let searchParms:any = {}
    search.split("&").map(item => {
      let i = item.split("=")
      searchParms[i[0]] = i[1]
      return item
    })
    // 将 特效id 转成 number 类型
    FTImageStore.defaultEffect = +searchParms["effect"]
    FTImageStore.defaultEffectClassify = searchParms["classify"]
  }

  loadLoginSdk = () => {
    utils.loadLoginScript().then(() => {
      FTUserStore.checkUserLogin()
        // 注册google一键登陆的回调
        window["login"] &&
          window["login"].loginSuccess((res: any) => {
            FTUserStore.checkUserLogin()
            FTUserStore.getUserActivity()
            FTUserStore.getShowCountryAd()
          });
    })
  }

  loadLanguage = async () => {
    await FTLang.updateLanguage()
    this.setState({
      loadLanguage: true
    })
  }
  loadPaymentSdk = () => {
    utils.loadPaymentSdk()
  }
  render() {
    return <React.Fragment>
      <Layout />
    </React.Fragment>
  }
}


function App() {
  function offline() {
    message.error(FTLang._("notification_network_offline"));
  }
  React.useEffect(() => {
    FTAnalytic.addAnalytic({
      type: 'ev',
      analyticType: "sa",
      action: 'fotor_web$enter$goart_project',
      label: {}
    })
    window.addEventListener("offline", offline);
    return () => {
      window.removeEventListener("offline", offline)
    }
  }, [])
  return (
      <Root />
  );
}

export default App;
